import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Checkbox } from '@sandtech-hub-monorepo/ui-kit';

interface FitSsoSignInProps {
  onEhubSignIn: () => void;
  loading: boolean;
  signInWithEhubLogo?: React.ReactNode;
}

export const FitSsoSignIn = ({ onEhubSignIn, loading }: FitSsoSignInProps) => {
  const [acceptedTerms, setAcceptedTerms] = useState(false);

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-4 items-start">
        <h1 className="text-2xl">
          <span className="font-normal">Welcome to</span>
          <br />
          <span className="font-semibold">
            Frontier Institute of Technology
          </span>
        </h1>
        <p className="text-base text-muted-foreground">
          Login with ALX account
        </p>
      </div>
      <Button
        onClick={onEhubSignIn}
        disabled={loading || !acceptedTerms}
        variant="outline"
        className="w-full h-11 border-primary text-primary hover:!bg-background-quaternary hover:!text-primary"
      >
        eHub Login
      </Button>
      <div className="flex gap-2 items-start">
        <Checkbox
          checked={acceptedTerms}
          onCheckedChange={(checked) => setAcceptedTerms(checked === true)}
          className="mt-0.5"
        />
        <p className="text-xs text-foreground">
          I accept Frontier&apos;s{' '}
          <Link
            to="https://www.frontiertech.edu/terms-of-use"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary underline"
          >
            terms of services
          </Link>{' '}
          and acknowledge Frontier&apos;s{' '}
          <Link
            to="https://frontiertech.edu/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary underline"
          >
            privacy policy
          </Link>
          .
        </p>
      </div>
    </div>
  );
};
